import { Check } from "lucide-react";
import styles from "./AutofillBadge.module.css";

interface AutofillBadgeProps {
  field: string;
  autofilledFields: Set<string> | undefined;
}

export function AutofillBadge({
  field,
  autofilledFields,
}: AutofillBadgeProps): React.JSX.Element | null {
  if (!autofilledFields?.has(field)) return null;
  return (
    <span className={styles.badge}>
      <Check className={styles.icon} />
      From your document
    </span>
  );
}
